
/**
 * => 의 내용을 팀내에서 모듈 형식으로 변경한 파일 입니다.
 * => 변경한 파일을 다시 typescript를 적용한 파일입니다
 * => typescript를 적용한 파일을 다시 ncui의 모듈로 리팩토링 한 파일입니다. 2023.07
 */

/**
 * recaptcha의 경우 checkbox 는 사용하지 않는게 현재의 내부 방침이다.
 *
 * 즉, 아래의 코드는 v2 + invisible 타입 고정이다. *
 * 구글 뱃치 위치는 옵션으로 제공
 */

// import type { ICaptchaConfig } from "../interface/ICaptcha";
import AbsCaptcha from "./AbsCaptcha";
import GoogleCaptcha, { BadgePosition } from "./GoogleCaptcha";
import WaveCaptcah from "./WaveCaptcha";

declare global {
  interface Window {
    grecaptcha: any
    grecaptchaOnload: any
  }
}

const CAPTCHA_INFO_API_PATH = '/captcha/info';

const ENV_LIST = ['live', 'rc', 'rc-tw', 'sb', 'sandbox', 'tw', 'op', 'dev', 'local'] as const;
export type Env = typeof ENV_LIST[number];

const CAPTCHA_PLATFORM_TYPE_LIST = ['google', 'wave'] as const
export type CaptchaType = typeof CAPTCHA_PLATFORM_TYPE_LIST[number];

type ResponseCaptchainfo = {
  type: CaptchaType,
  clientKey: string
};

export type ICaptchaConfig = {
    env: Env,
    wrapperElementId: string
    googleCaptchaOption?: {
        badge: BadgePosition
    }
}

export default class Captcha {
  env: Env;
  ElWrapperId: string;
  googleBadgePosition?: BadgePosition;
  #captchaInstance?: AbsCaptcha;

  constructor({ env, wrapperElementId, googleCaptchaOption }: ICaptchaConfig) {

    this.env = env;
    this.ElWrapperId = wrapperElementId;
    this.googleBadgePosition = googleCaptchaOption?.badge;
  }

  async init() {
    if (!this.ElWrapperId || !this.env) {
      console.error('Captcha 생성자 함수 실행시 필수 인자를 넘겨주지 않았습니다.');
      return null;
    }
    if(!ENV_LIST.includes(this.env)){
        console.error('허용하지 않는 env 값 입니다', this.env);
        return null;
    }
    if(!document.getElementById(this.ElWrapperId)){
        console.error('존재하지 않는 wrapperElementId 입니다.', this.ElWrapperId);
        return null;
    }

    try {
      const CAPTCHA_INFO_API_DOMAIN = this.captchaApiDomain;
      const SERVE_CAPTCHA_INFO: ResponseCaptchainfo = await (await fetch(`${CAPTCHA_INFO_API_DOMAIN}${CAPTCHA_INFO_API_PATH}`)).json();

      if (SERVE_CAPTCHA_INFO.type === 'google') {
        // 구글 캡챠
        this.#captchaInstance = new GoogleCaptcha(this.ElWrapperId, SERVE_CAPTCHA_INFO.type, SERVE_CAPTCHA_INFO.clientKey, this.googleBadgePosition );
        return await this.#captchaInstance.init();

      } else if (SERVE_CAPTCHA_INFO.type === 'wave') {
        // 웨이브 캡챠
        this.#captchaInstance = new WaveCaptcah(this.ElWrapperId, SERVE_CAPTCHA_INFO.type, SERVE_CAPTCHA_INFO.clientKey, CAPTCHA_INFO_API_DOMAIN);
        return await this.#captchaInstance.init();

      } else {
        // 구글/웨이브 둘다 아닌경우 (이런경우가 있나?)
        console.error('Captcha Create Error');
        return null;
      }
    } catch (err) {
      console.error('Captcha Create Error: ' + err);
      return null;
    }
  }

  refresh(){
    return this.#captchaInstance?.refresh();
  }

  execute(){
    return this.#captchaInstance?.execute();
  }

  get captchaData(){
    return this.#captchaInstance?.captchaData;
  }

  private get captchaApiDomain() {
    switch (this.env) {
      case 'tw':
        return 'https://tw.ncsoft.com';
      case 'rc-tw':
        return 'https://rc-tw.ncsoft.com';
      case 'op':
        return 'https://op-captcha.plaync.com';
      case 'dev':
        return 'http://dev.captcha.plaync.com';
      case 'rc':
        return 'https://rc-captcha.plaync.com';
      case 'sandbox':
      case 'sb':
      case 'local':
        return 'https://captcha.sb.plaync.com';
      default:
        return 'https://captcha.plaync.com';
    }
  }
}




